import { apiClient } from '@shared/utils/api-client';
import type { BonusRule, CreateBonusRuleDto, UpdateBonusRuleDto, BonusUser, ManualBonusAdjustDto } from '../types';

export const bonusesApi = {
  getAllRules: async (): Promise<BonusRule[]> => {
    return apiClient.get<BonusRule[]>('/bonuses/rules');
  },

  getRule: async (id: number): Promise<BonusRule> => {
    return apiClient.get<BonusRule>(`/bonuses/rules/${id}`);
  },

  createRule: async (data: CreateBonusRuleDto): Promise<BonusRule> => {
    return apiClient.post<BonusRule>('/bonuses/rules', data);
  },

  updateRule: async (id: number, data: UpdateBonusRuleDto): Promise<BonusRule> => {
    return apiClient.put<BonusRule>(`/bonuses/rules/${id}`, data);
  },

  deleteRule: async (id: number): Promise<void> => {
    return apiClient.delete(`/bonuses/rules/${id}`);
  },

  runActivatePendingCron: async (): Promise<{
    ok: boolean;
    message: string;
    datesAdjusted: number;
    activated: number;
  }> => {
    return apiClient.post('/bonuses/cron/activate-pending', {});
  },

  runExpireCron: async (): Promise<{ ok: boolean; expired: number; expiredAmount: string; message: string }> => {
    return apiClient.post<{ ok: boolean; expired: number; expiredAmount: string; message: string }>(
      '/bonuses/cron/expire',
      {},
    );
  },

  runSendExpiringRemindersCron: async (): Promise<{ ok: boolean; message: string }> => {
    return apiClient.post<{ ok: boolean; message: string }>(
      '/bonuses/cron/send-expiring-reminders',
      {},
    );
  },

  getUsers: async (
    phone?: string,
    options?: { onlyShopClients?: boolean },
  ): Promise<BonusUser[]> => {
    const params = new URLSearchParams();
    if (phone) params.set('phone', phone);
    if (options?.onlyShopClients) params.set('onlyShopClients', 'true');
    const qs = params.toString();
    return apiClient.get<BonusUser[]>(`/bonuses/users${qs ? `?${qs}` : ''}`);
  },

  manualAdjust: async (data: ManualBonusAdjustDto) => {
    return apiClient.post('/bonuses/adjust', data);
  },
};
